
export const columns = [
    {
        title: "序号",
        dataIndex: "ranking",
        key: "ranking",
        width: 100,
        fixed: 'left',
        hidden:false,
    },
    {
        title: "测试主体",
        dataIndex: "application",
        key: "application",
        // width: 150,
        hidden:false,
    },
    {
        title: "测试牌照",
        key: "testPlate",
        dataIndex: "testPlate",
        hidden:false,
    },
    {
        title: "测试区域",
        key: "testArea",
        dataIndex: "testArea",
        hidden:false,
    },
    {
        title: "片区/道路名称",
        key: "roadName",
        dataIndex: "roadName",
        hidden:false,
    },
    {
        title: "测试类型",
        key: "testType",
        dataIndex: "testType",
        hidden:false,
    },
    {
        title: "审批结果",
        key: "result",
        dataIndex: "result",
        hidden:true,
    },
    {
        title: "更新时间",
        key: "updateTime",
        dataIndex: "updateTime",
        hidden:false,
    },
    {
        title: "操作",
        key: "action",
        fixed: 'right',
        hidden:false,
        // width: 240,
    },
];

//已审核
export const columns2 = [
    {
        title: "序号",
        dataIndex: "ranking",
        key: "ranking",
        width: 100,
        fixed: 'left',
        hidden:false,
    },
    {
        title: "测试牌照",
        key: "testPlate",
        dataIndex: "testPlate",
        hidden:false,
    },
    {
        title: "测试区域",
        key: "testArea",
        dataIndex: "testArea",
        hidden:false,
    },
    {
        title: "片区/道路名称",
        key: "roadName",
        dataIndex: "roadName",
        hidden:false,
    },
    {
        title: "测试类型",
        key: "testType",
        dataIndex: "testType",
        hidden:false,
    },
    {
        title: "审批结果",
        key: "result",
        dataIndex: "result",
        hidden:true,
    },
    {
        title: "更新时间",
        key: "updateTime",
        dataIndex: "updateTime",
        hidden:false,
    },
    {
        title: "操作",
        key: "action",
        fixed: 'right',
        hidden:false,
        // width: 240,
    },
];


